import React from 'react';
import { PublicFeed } from '@src/layouts';
import {
  LearningList,
  generateLearningFilters,
  SubnavWithPriceSlider,
  MagazineList,
  generateMagazineFilters
} from '@src/features/feed';
import { getLearningPath, getLearningTopPicksPath, getMagazinesPath } from '@src/services/board';
import { EmployerNav } from './organisms';

const Page = function () {
  return (
    <PublicFeed
      store="magazineList"
      activeIndex={1}
      content={<MagazineList {...{ getData: getMagazinesPath }} />}
      generateFilters={generateMagazineFilters}
      header={<EmployerNav />}
      marginTop="75px"
      subnav={
        <SubnavWithPriceSlider
          {...{ activeIndex: 1, store: 'magazineList', generateFilters: generateMagazineFilters }}
        />
      }
    />
  );
};

export default Page;
